import { MarketoProgramObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type ProgramDeletionResponse = {
    result: string;
}

type UseProgramDeletionResponse = [
    (data: MarketoProgramObject) => Promise<ProgramDeletionResponse | null>,
    {
        value?: ProgramDeletionResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useDeleteExistingProgram = (): UseProgramDeletionResponse => {
    
    const [post, postState] = usePost<ProgramDeletionResponse, MarketoProgramObject>({
        url: `settings/delete-program`
    })

    const deleteProgram = async (
        data : MarketoProgramObject
    ) : Promise<ProgramDeletionResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [deleteProgram, postState];
};